<template>
  <div>
    <preamble v-bind="preamble" />
    <pop v-bind="popContent" v-on:popClose="closePop" />
    <section class="main single-chapter">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="columns mb-3">
                    </div>
                    <div class="columns">
                        <div class="column" v-for="(image, index) in chapterImages" :key="index"
                            v-bind:class="{ 'is-8': (index % 2) < 0, 'is-4': (index % 2) > 0 }"
                            >
                            <div class="chapter bg-black">
                                <img v-bind:src="image" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="columns mt-1 mb-3">
                        <div class="column is-10 is-offset-2">
                           <div v-if="chapter.longDescription" v-html="chapter.longDescription"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns next-chapter">

                <div class="column is-8 is-offset-2">
                    <div class="columns">
                        <div class="column is-2"><span class="dash"></span></div>
                        <div class="column is-8"><div><h3>Gallery</h3></div></div>
                    </div>
                    <div class="columns gallery">
                        <img class="image column is-2" v-for="(image, i) in images" :src="image" :key="i" @click="index = i">
                        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                    </div>
                </div>
            </div>

            <div class="columns next-chapter">

                <div class="column is-8 is-offset-2">
                    <div class="columns">
                        <div class="column is-2"><span class="dash"></span></div>
                        <div class="column is-8"><div><h3>Next Chapter</h3></div></div>
                    </div>
                    <div class="columns">
                        <div class="column is-12">
                            <div class="chapter" @click="gotoChapter">
                                <h3>{{ nextChapter.title}}</h3>
                                <h5>{{ nextChapter.chapter}}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import Pop from '@/components/Pop.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources, API } from '@/utils/constants'
    import VueGallerySlideshow from 'vue-gallery-slideshow';

    export default {
        name: "Chapter",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble, Pop, VueGallerySlideshow 
                },
        data() {
            return {
              // triggered: true,
              chapter: {},
              chapterImages: [],
              chapters: [],
              preamble: {
                title: 'Loading...',
                subTitle: '...',
                secondaryTitle: '',
                description: '',
                watchVideo: '',
              },
              nextChapter: {},
              popContent: {
                triggered: false,
                title: 'The disease now has a name: "Slim"',
                description: 'In Uganda, during the 1980’s and 1990’s behavioural change communication (BCC) campaigns were effective in reducing the spread of HIV. Many younger people may be complacent about HIV as they have not lived through the times when HIV was killing thousands of people weekly before effective treatment was available.',
              },
              currentLine: {
                id: '101',
                year: '1968',
                title: 'The disease now has a name: "Slim"',
                shortDescription: '“A neighbour and later her boyfriend die in Makindye after suffering from a strange disease”. First memories of a strange disease manifesting symptoms similar to AIDS.',
                longDescription: '',
                image: '' 
              },
              timeLine : [
                {
                  id: '',
                  year: '',
                  title: '',
                  shortDescription: '',
                  longDescription: '', 
                  image: ''
                }
              ],
              images: [],
              index: null
            }
        },
        created() {

          const chapterId = this.$route.params.id;

          if(chapterId) {
              this.read(`${resources.chapter}/${chapterId}`)
                  .then(response => {
                  this.chapter = response.data[0]

                  this.preamble = {
                          title: this.chapter.title, 
                          subTitle: this.chapter.chapter,
                          secondaryTitle: this.chapter.subTitle,
                          description: this.chapter.shortDescription,
                          watchVideo: this.chapter.videoLink,
                      }
                  if(this.chapter.images){
                      this.chapterImages = this.chapter.images.split(', ').map(image => `${API}${image}`)
                  }
                  if(this.chapter.gallery){
                      this.images = this.chapter.gallery.split(', ').map(image => `${API}${image}`)
                  }
              })
          }

          this.getNextChapter()

        },
        mounted() {
           

        },
        methods: {
          getNextChapter() {
            //Fetch all chapters
            this.read(`${resources.chapter}`)
              .then(response => {
                this.chapters = response.data;
                const currentChapter = this.chapters.findIndex(chapter => chapter.id === this.$route.params.id);

                if (currentChapter >= (this.chapters.length - 1)){
                  this.nextChapter = this.chapters[0]
                } else {
                  this.nextChapter = this.chapters[(currentChapter + 1)]
                }
              })
          },

          gotoChapter() {
            let id = this.nextChapter.id
            this.$router.push({ name: 'Chapter', params: { id } })
            this.$router.go();
          },

          handleTimelineMove(currentId, direction) {
            const TotalItems = this.timeLine.length;

            if(direction){
              const currentTimelineIndex = this.timeLine.findIndex(lineItem => lineItem.id === currentId);
              if(direction === 'right') {

                
                if (currentTimelineIndex >= (TotalItems - 1)){
                  this.currentLine = this.timeLine[0]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex + 1)]
                }
              } else {
                if (currentTimelineIndex <= 0){
                  this.currentLine = this.timeLine[(TotalItems - 1)]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex - 1)]
                }
              }

            } else {
              const selectedLineItem = this.timeLine.find( ({ id }) => id === currentId );
              this.currentLine = selectedLineItem
            }
          },

          handlePop() {
            this.popContent = {...this.currentLine, triggered: true}
          },

          closePop() {
            this.popContent.triggered = false;
          }
        },
        computed: {
             
        },
    }
</script>

<style>
</style>
